import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function RenterDashboard() {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-100">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="text-2xl font-bold text-blue-600">
              OVERHEAD<span className="text-gray-600">PM</span>
            </Link>
            <div className="flex items-center space-x-4">
              <button className="p-2 text-gray-600 hover:text-blue-600 transition-colors">
                <span className="sr-only">Notifications</span>
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
              </button>
              <div className="relative">
                <button className="flex items-center space-x-2 text-gray-600 hover:text-blue-600 transition-colors">
                  <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                    <span className="text-blue-600 font-medium">JD</span>
                  </div>
                  <span>John Doe</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar */}
          <aside className="lg:w-64 space-y-4">
            <div className="bg-white rounded-lg border border-gray-100 p-4">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center">
                  <span className="text-2xl">🏠</span>
                </div>
                <div>
                  <h2 className="font-semibold text-gray-900">123 Main St</h2>
                  <p className="text-sm text-gray-600">Apt 4B</p>
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Lease End</span>
                  <span className="text-gray-900">Dec 31, 2024</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Next Payment</span>
                  <span className="text-gray-900">$1,500</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Due Date</span>
                  <span className="text-gray-900">Mar 1, 2024</span>
                </div>
              </div>
            </div>

            <nav className="bg-white rounded-lg border border-gray-100 p-4">
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={() => setActiveTab('overview')}
                    className={`w-full flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${
                      activeTab === 'overview'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                    <span>Overview</span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveTab('payments')}
                    className={`w-full flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${
                      activeTab === 'payments'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                    </svg>
                    <span>Payments</span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveTab('maintenance')}
                    className={`w-full flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${
                      activeTab === 'maintenance'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span>Maintenance</span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveTab('documents')}
                    className={`w-full flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${
                      activeTab === 'documents'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span>Documents</span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setActiveTab('messages')}
                    className={`w-full flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors ${
                      activeTab === 'messages'
                        ? 'bg-blue-50 text-blue-600'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                    </svg>
                    <span>Messages</span>
                  </button>
                </li>
              </ul>
            </nav>
          </aside>

          {/* Main Content Area */}
          <main className="flex-1 space-y-6">
            {/* Overview Section */}
            {activeTab === 'overview' && (
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-white rounded-lg border border-gray-100 p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-gray-600">Balance Due</h3>
                      <span className="text-blue-600">$1,500</span>
                    </div>
                    <div className="w-full bg-gray-100 rounded-full h-2">
                      <div className="bg-blue-600 h-2 rounded-full" style={{ width: '75%' }}></div>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg border border-gray-100 p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-gray-600">Next Payment</h3>
                      <span className="text-blue-600">Mar 1, 2024</span>
                    </div>
                    <div className="w-full bg-gray-100 rounded-full h-2">
                      <div className="bg-green-500 h-2 rounded-full" style={{ width: '25%' }}></div>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg border border-gray-100 p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-gray-600">Lease Status</h3>
                      <span className="text-green-500">Active</span>
                    </div>
                    <div className="w-full bg-gray-100 rounded-full h-2">
                      <div className="bg-green-500 h-2 rounded-full" style={{ width: '60%' }}></div>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-100 p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Activity</h3>
                  <div className="space-y-4">
                    {[
                      {
                        type: 'payment',
                        description: 'Rent payment received',
                        amount: '$1,500',
                        date: 'Feb 1, 2024',
                        status: 'completed'
                      },
                      {
                        type: 'maintenance',
                        description: 'Maintenance request submitted',
                        amount: 'Kitchen sink repair',
                        date: 'Jan 28, 2024',
                        status: 'pending'
                      },
                      {
                        type: 'document',
                        description: 'Lease renewal document signed',
                        amount: '2024-2025',
                        date: 'Jan 15, 2024',
                        status: 'completed'
                      }
                    ].map((activity, index) => (
                      <div key={index} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0">
                        <div className="flex items-center space-x-3">
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                            activity.type === 'payment' ? 'bg-blue-100' :
                            activity.type === 'maintenance' ? 'bg-yellow-100' :
                            'bg-green-100'
                          }`}>
                            <span className={`text-sm ${
                              activity.type === 'payment' ? 'text-blue-600' :
                              activity.type === 'maintenance' ? 'text-yellow-600' :
                              'text-green-600'
                            }`}>
                              {activity.type === 'payment' ? '💰' :
                               activity.type === 'maintenance' ? '🔧' :
                               '📄'}
                            </span>
                          </div>
                          <div>
                            <p className="text-gray-900">{activity.description}</p>
                            <p className="text-sm text-gray-500">{activity.date}</p>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="text-gray-900">{activity.amount}</p>
                          <span className={`text-sm ${
                            activity.status === 'completed' ? 'text-green-500' : 'text-yellow-500'
                          }`}>
                            {activity.status}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Payments Section */}
            {activeTab === 'payments' && (
              <div className="space-y-6">
                <div className="bg-white rounded-lg border border-gray-100 p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Payment History</h3>
                  <div className="space-y-4">
                    {[
                      {
                        date: 'Feb 1, 2024',
                        amount: '$1,500',
                        status: 'Completed',
                        method: 'Bank Transfer'
                      },
                      {
                        date: 'Jan 1, 2024',
                        amount: '$1,500',
                        status: 'Completed',
                        method: 'Bank Transfer'
                      },
                      {
                        date: 'Dec 1, 2023',
                        amount: '$1,500',
                        status: 'Completed',
                        method: 'Bank Transfer'
                      }
                    ].map((payment, index) => (
                      <div key={index} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0">
                        <div>
                          <p className="text-gray-900">{payment.date}</p>
                          <p className="text-sm text-gray-500">{payment.method}</p>
                        </div>
                        <div className="text-right">
                          <p className="text-gray-900">{payment.amount}</p>
                          <span className="text-sm text-green-500">{payment.status}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-100 p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Make a Payment</h3>
                  <form className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Amount</label>
                      <input
                        type="number"
                        className="w-full px-4 py-2 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900 placeholder:text-gray-400"
                        placeholder="Enter amount"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Payment Method</label>
                      <select className="w-full px-4 py-2 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900">
                        <option>Bank Transfer</option>
                        <option>Credit Card</option>
                        <option>Debit Card</option>
                      </select>
                    </div>
                    <button
                      type="submit"
                      className="w-full px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all"
                    >
                      Pay Now
                    </button>
                  </form>
                </div>
              </div>
            )}

            {/* Maintenance Section */}
            {activeTab === 'maintenance' && (
              <div className="space-y-6">
                <div className="bg-white rounded-lg border border-gray-100 p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Submit Maintenance Request</h3>
                  <form className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Issue Type</label>
                      <select className="w-full px-4 py-2 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900">
                        <option>Plumbing</option>
                        <option>Electrical</option>
                        <option>HVAC</option>
                        <option>Appliance</option>
                        <option>Other</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
                      <textarea
                        className="w-full px-4 py-2 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900 placeholder:text-gray-400"
                        rows="4"
                        placeholder="Describe the issue in detail"
                      ></textarea>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Photos</label>
                      <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-lg">
                        <div className="space-y-1 text-center">
                          <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                            <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <div className="flex text-sm text-gray-600">
                            <label className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500">
                              <span>Upload photos</span>
                              <input type="file" className="sr-only" multiple />
                            </label>
                            <p className="pl-1">or drag and drop</p>
                          </div>
                          <p className="text-xs text-gray-500">PNG, JPG, GIF up to 10MB</p>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="w-full px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all"
                    >
                      Submit Request
                    </button>
                  </form>
                </div>

                <div className="bg-white rounded-lg border border-gray-100 p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Requests</h3>
                  <div className="space-y-4">
                    {[
                      {
                        type: 'Plumbing',
                        description: 'Kitchen sink is leaking',
                        date: 'Jan 28, 2024',
                        status: 'Pending'
                      },
                      {
                        type: 'Electrical',
                        description: 'Light fixture not working',
                        date: 'Jan 15, 2024',
                        status: 'Completed'
                      }
                    ].map((request, index) => (
                      <div key={index} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0">
                        <div>
                          <p className="text-gray-900">{request.type}</p>
                          <p className="text-sm text-gray-500">{request.description}</p>
                          <p className="text-sm text-gray-500">{request.date}</p>
                        </div>
                        <span className={`px-3 py-1 rounded-full text-sm ${
                          request.status === 'Completed' ? 'bg-green-100 text-green-600' : 'bg-yellow-100 text-yellow-600'
                        }`}>
                          {request.status}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Documents Section */}
            {activeTab === 'documents' && (
              <div className="space-y-6">
                <div className="bg-white rounded-lg border border-gray-100 p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Your Documents</h3>
                  <div className="space-y-4">
                    {[
                      {
                        name: 'Lease Agreement',
                        type: 'PDF',
                        size: '2.4 MB',
                        date: 'Jan 15, 2024'
                      },
                      {
                        name: 'Move-in Checklist',
                        type: 'PDF',
                        size: '1.2 MB',
                        date: 'Jan 15, 2024'
                      },
                      {
                        name: 'Renters Insurance',
                        type: 'PDF',
                        size: '3.1 MB',
                        date: 'Jan 15, 2024'
                      }
                    ].map((doc, index) => (
                      <div key={index} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0">
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                            <span className="text-blue-600">📄</span>
                          </div>
                          <div>
                            <p className="text-gray-900">{doc.name}</p>
                            <p className="text-sm text-gray-500">{doc.type} • {doc.size}</p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-4">
                          <span className="text-sm text-gray-500">{doc.date}</span>
                          <button className="text-blue-600 hover:text-blue-700">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Messages Section */}
            {activeTab === 'messages' && (
              <div className="space-y-6">
                <div className="bg-white rounded-lg border border-gray-100 p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Messages</h3>
                  <div className="space-y-4">
                    {[
                      {
                        sender: 'Property Manager',
                        message: 'Your maintenance request has been received and will be addressed within 24 hours.',
                        time: '2 hours ago',
                        unread: true
                      },
                      {
                        sender: 'System',
                        message: 'Your rent payment has been received. Thank you!',
                        time: '1 day ago',
                        unread: false
                      }
                    ].map((msg, index) => (
                      <div key={index} className="flex items-start space-x-4 py-3 border-b border-gray-100 last:border-0">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                          msg.unread ? 'bg-blue-100' : 'bg-gray-100'
                        }`}>
                          <span className={msg.unread ? 'text-blue-600' : 'text-gray-600'}>
                            {msg.sender === 'Property Manager' ? '👨‍💼' : '🤖'}
                          </span>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center justify-between">
                            <p className="font-medium text-gray-900">{msg.sender}</p>
                            <span className="text-sm text-gray-500">{msg.time}</span>
                          </div>
                          <p className="text-gray-600 mt-1">{msg.message}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-100 p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Send Message</h3>
                  <form className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                      <textarea
                        className="w-full px-4 py-2 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900 placeholder:text-gray-400"
                        rows="4"
                        placeholder="Type your message here..."
                      ></textarea>
                    </div>
                    <button
                      type="submit"
                      className="w-full px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all"
                    >
                      Send Message
                    </button>
                  </form>
                </div>
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
}

export default RenterDashboard; 